import { render, staticRenderFns } from "./SelectDonationFieldset.vue?vue&type=template&id=5ca83c1a&"
import script from "./SelectDonationFieldset.vue?vue&type=script&lang=js&"
export * from "./SelectDonationFieldset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports